// extracted by mini-css-extract-plugin
module.exports = {"minHeight":"HittingSummary_minHeight_1ChHI"};